module.exports = __webpack_public_path__ + "static/media/1-min.9228adf9.jpg";